//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/DateBuilder.js";
import "../no/DateBuilder.js";
let d=[[[0,"AutoCompletionCustomPixelRatio",1,0],[0,"AutoCompletionCustomQualityFactor",1,0],[0,"DynamicIRayPlusCaustics",1,0],[0,"DynamicIRayPlusStudioRenderMode",1,0],[1,"DynamicIRayPlusStudioTime",0,"DateBuilder",0],[0,"EyeSeparation",1,0],[0,"IRayPlusStudioDenoiserToggle",1,0],[0,"IRayPlusStudioOptimizePerformanceToggle",1,0],[0,"IRayPlusStudioStaticImageDotsPerInch",1,1],[0,"IRayPlusStudioStaticImageDoubleHeight",1,1],[0,"IRayPlusStudioStaticImageDoubleWidth",1,1],[0,"IRayPlusStudioStaticImageFileFormat",1,0],[0,"IRayPlusStudioStaticImageLockAspectRatio",1,1],[0,"IRayPlusStudioStaticImageOrientation",1,1],[0,"IRayPlusStudioStaticImagePixelHeight",1,0],[0,"IRayPlusStudioStaticImagePixelWidth",1,0],[0,"IRayPlusStudioStaticImageResolution",1,1],[0,"IRayPlusStudioStaticImageSize",1,0],[0,"IRayPlusStudioStaticImageUnits",1,1],[0,"IRayPlusStudioStaticImageVrHeight",1,0],[0,"IRayPlusStudioStaticImageVrWidth",1,0],[0,"IRayPlusStudioshowStatusIndicator",1,0],[0,"LensType",1,0],[0,"RemoteRenderFormat",1,0],[0,"RemoteRenderIP",1,0],[0,"RemoteRenderPassword",1,0],[0,"RemoteRenderReserveNodes",1,0],[0,"RemoteRenderSecurityToken",1,0],[0,"RemoteRenderToggle",1,0],[0,"RemoteRenderType",1,0],[0,"RemoteRenderUsername",1,0],[0,"RemoteRenderVideoMode",1,1],[0,"StaticAutoCompletionType",1,0],[1,"StaticIRayPlusStudioTime",0,"DateBuilder",0],[0,"StaticRenderDuration",1,0],[0,"StaticRenderNumberOfIterations",1,0],[0,"StereoLayout",1,0],[0,"VrCamera",1,"CartesianCoordinateSystem",0],[0,"VrEnabledToggle",1,0]],[],[]];
SPLM.Display.IRayPlusStudioPreferencesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.IRayPlusStudioPreferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.IRayPlusStudioPreferencesBuilder.DynamicIRayPlusStudioRenderModeType = Object.freeze({
    "Photoreal" : "Photoreal", "QualityInteractive" : "QualityInteractive", "FastInteractive" : "FastInteractive"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioStaticImageFileFormatType = Object.freeze({
    "Tif" : "Tif", "Png" : "Png", "Jpg" : "Jpg"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioStaticImageUnitsType = Object.freeze({
    "Pixels" : "Pixels", "Millimeters" : "Millimeters", "Inches" : "Inches"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioStaticImageSizeType = Object.freeze({
    "RenderWindow" : "RenderWindow", "UserDefined" : "UserDefined"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioStaticImageOrientationType = Object.freeze({
    "Landscape" : "Landscape", "Portrait" : "Portrait"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioStaticImageResolutionType = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low", "UserDefined" : "UserDefined"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioRemoteRenderVideoType = Object.freeze({
    "Streaming" : "Streaming", "Synchronous" : "Synchronous"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioRemoteRenderFormatType = Object.freeze({
    "H264" : "H264", "Lossless" : "Lossless", "Png" : "Png", "Jpeg" : "Jpeg"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioRemoteRenderType = Object.freeze({
    "Cluster" : "Cluster", "Vca" : "Vca", "SecuredCluster" : "SecuredCluster"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioLensType = Object.freeze({
    "Monospherical" : "Monospherical", "Stereospherical" : "Stereospherical"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioAutoCompletionType = Object.freeze({
    "Simple" : "Simple", "Normal" : "Normal", "Complex" : "Complex", "None" : "None", "Custom" : "Custom"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.StaticRenderDurationType = Object.freeze({
    "NumberOfIterations" : "NumberOfIterations", "TimeLimit" : "TimeLimit", "AutoComplete" : "AutoComplete", "TimeLimitedAutoComplete" : "TimeLimitedAutoComplete"});

SPLM.Display.IRayPlusStudioPreferencesBuilder.IRayPlusStudioStereoLayoutType = Object.freeze({
    "TopBottom" : "TopBottom", "SideBySide" : "SideBySide"});

export default SPLM;